import * as React from "react";
import { IParagraphPageTeaserProps } from "./ParagraphPageTeaserProps";
import { graphql } from "gatsby";
import PageTeaser from "../../common/PageTeaser/PageTeaser";
import { Container } from "react-bootstrap";
import { teaserContainer } from "./ParagraphPageTeaser.module.scss";

const ParagraphPageTeaser: React.FC<IParagraphPageTeaserProps> = (props) => {
  return (
    <Container className={teaserContainer}>
      <PageTeaser {...props.node} backgroundColor={props.backgroundColor} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphPageTeaser on paragraph__page_teaser {
    id
    parent_type
    field_title
    field_subtitle
    field_description
    field_image_position
    field_link {
      url
      title
    }
    relationships {
      field_sites {
        machine_name
      }
      field_media {
        relationships {
          desktopImage: field_media_image {
            publicUrl
            gatsbyImage(
              width: 800
              height: 555
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
          mobileImage: field_media_image {
            publicUrl
            gatsbyImage(
              width: 490
              height: 360
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
  }
`;
export default ParagraphPageTeaser;
